// export const environment = {
//   production: true,
//   apiUrl: '62.74.232.210',
//   apiPort: '7999',
//   apiType: 'http',
//   keycloakUrl: "https://sso.wings-ict-solutions.dev/auth"
// };

export const environment = {
  production: false,
  apiUrl: 'ditect.wings-ict-solutions.dev',
  apiPort: '',
  apiType: 'https',
  keycloakUrl: "https://sso.wings-ict-solutions.dev/auth"
};

// export const environment = {
//   production: false,
//   apiUrl: '192.168.61.45',
//   apiPort: '8080',
//   apiType: 'http'
// };
